const semanticClassNames = {
  root: 'fast-gallery',
  container: 'fast-gallery__container',
  overlay: 'fast-gallery__overlay',
  item: 'fast-gallery__item',
  content: 'fast-gallery__content',
  media: 'fast-gallery__media',
  details: 'fast-gallery__details',
  image: 'fast-gallery__image',
  title: 'fast-gallery__title',
  description: 'fast-gallery__description',
  counter: 'fast-gallery__counter',
} as const;

export default semanticClassNames;
